import Service from "../../services";
import Swal from "sweetalert2";

const viewModule = {
  namespaced: true,
  state: {
    select_plant: {
      bio_name: "",
      bio_scientific_name: "",
      bio_local_name: "",
      category: {
        name: "",
      },
      habits: {
        name: "",
      },
      habitat: {
        havest_season: "",
      },
      characteristic: "",
      benefit: [{ name: "" }],
      knowledge: [{ name: "" }],
    },
    plant_list: null,
    pagination: {
      page: 1,
      itemsPerPage: 5,
      pageStart: 1,
      pageStop: 1,
      pageCount: 0,
    },
    community_list: [],
    overview: {
      plants: "",
      community: "",
    },
    total_item_list: 0,
  },
  mutations: {
    SET_PLANT(state, data) {
      //data.image_url = JSON.parse(data.image_url)
      console.log(data);
      state.select_plant = data;
    },
    SET_PLANT_LIST(state, data) {
      //data.image_url = JSON.parse(data.image_url)
      state.plant_list = data.data;
      state.total_item_list = data.total;
    },
    SET_COMMUNITY_LIST(state, data) {
      state.community_list = data;
    },
    SET_PLANT_LIST_PAGINATE(state, data) {
      //data.image_url = JSON.parse(data.image_url)
      state.pagination = data;
    },
    SET_OVERVIEW(state, data) {
      state.overview.community = data.community;
      state.overview.plants = data.plants;
    },
  },
  actions: {
    onGetPlantDetail({ commit }, data) {
      return Service.ViewAPI.getPlantDetail(data).then((res) => {
        if (res.code == 200) {
          commit("SET_PLANT", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },

    onGetPlantList({ commit }, data) {
      return Service.ViewAPI.getPlantList(data).then((res) => {
        if (res.code == 200) {
          //commit("SET_PLANT_List", res.result);
          commit("SET_PLANT_LIST", res.result.data);
          commit("SET_COMMUNITY_LIST", res.result.community);
          commit("SET_PLANT_LIST_PAGINATE", {
            page: res.result.data.current_page,
            itemsPerPage: res.result.data.per_page,
            pageStart: res.result.data.from,
            pageStop: res.result.data.last_page,
            pageCount: Math.ceil(res.result.data.total / 5),
          });
          return res.code;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    onGetOverview({ commit }) {
      return Service.ViewAPI.getOverview().then((res) => {
        if (res.code == 200) {
          commit("SET_OVERVIEW", res.result);
        }
      });
    },
    onGetViewPlantByName({ commit }, name) {
      return Service.ViewAPI.getViewPlantByName(name).then((res) => {
        return res;
      });
    },
  },
};

export default viewModule;
